import React from "react";
import { HelpCircleIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { considerQuestions } from "../../data/content";
export function Problem() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-250" data-mp="2ro5889u50zk4">
      <div className="mx-auto max-w-3xl" data-id="element-251" data-mp="2rmakyove8vcv">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-ink sm:text-4xl" data-id="element-252" data-mp="2mptz61bo2t2y">
          From Looking at an Endodontically Treated Tooth and Wondering What to Do Next… to Having a{" "}
          <span className="text-brand-deep" data-id="element-253" data-mp="2cq31xrvq1zz6">Structured Restorative Plan.</span>
        </h2>
        <p className="mt-6 text-center text-[17px] leading-relaxed text-slate-600" data-id="element-254" data-mp="28or9lelgr0na">
          You shouldn’t have to rely on scattered notes, disconnected concepts, or memory every time you evaluate a tooth after root canal treatment. Before selecting a post, rebuilding the core, or deciding on a definitive restoration, you need to understand what you’re working with.
        </p>

        <p className="mt-8 font-display text-lg font-extrabold text-ink" data-id="element-255" data-mp="14bbqw28riosp">You need to consider:</p>
        <ul className="mt-4 divide-y divide-slate-200 border-y border-slate-200" data-id="element-256" data-mp="199wv0cr4xsmf">
          {considerQuestions.map(q => <li key={q} className="flex items-start gap-3 py-3.5" data-id="element-257" data-mp="vbfasp0fuy99">
              <HelpCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-deep" aria-hidden data-id="element-258" data-mp="1096zla5se498" />
              <span className="text-base font-medium text-slate-800" data-id="element-259" data-mp="1nz1fk0lek8xp">{q}</span>
            </li>)}
        </ul>

        <div className="mt-10 rounded-2xl bg-navy p-6 text-center" data-id="element-260" data-mp="1s0wbsqoh7w4m">
          <p className="font-display text-xl font-black text-white" data-id="element-261" data-mp="1e99eqompmjks">That’s exactly why I created Post-Endodontic Restoration Blueprint™.</p>
          <p className="mt-2 text-mist" data-id="element-262" data-mp="1j7awn68egcuo">My goal is to give you a structured educational framework to help you organize these decisions before committing to a restorative approach.</p>
        </div>

        <div className="mt-10" data-id="element-263" data-mp="2bovr8etzjrgd">
          <CTAButton label="I want a clearer restorative planning system" data-id="element-264" data-mp="2bpyd28cgb3pf" />
        </div>
      </div>
    </section>;
}